<wiz-vgroup width="100%" height="100%" padding="5px" class="section-container">
  <wiz-hgroup
    width="100%"
    height="30px"
    verticalAlign="center"
    padding="3px"
    gap="2"
    class="background-title"
  >
    <wiz-label #lblTitle width="100%"></wiz-label>
    <wiz-icon (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <div
    #editDiv
    height="45px"
    class="formula-div"
    [innerHtml]="currentFormulaHtml"
    (dblclick)="showEditorFromDiv($event)"
    style="overflow-y: auto; user-select: none"
  ></div>
  <div #errorDiv spellcheck="false" height="15px" [innerHtml]="currentErrorHtml" class="edit-tool-error"></div>

  <wiz-hgroup width="100%" height="100%" gap="10">
    <wiz-vgroup width="100%" height="100%">
      <!-- zone édition de formules -->

      <wiz-hgroup
        width="100%"
        height="30px"
        verticalAlign="center"
        padding="3px"
        gap="2"
        class="background-title"
      >
        <wiz-label #lblSubTitle width="100%"></wiz-label>
        <wiz-icon #subClose (click)="closeSub()">close</wiz-icon>
      </wiz-hgroup>

      <wiz-text-area
        #mainEdit
        width="100%"
        height="80px"
        [wizShowLabel]="false"
        (dblclick)="showEditor()"
        (keyup)="checkCaret()"
        (click)="checkCaret()"
        [wizValue]="currentFormula"
      ></wiz-text-area>
      <div #descDiv spellcheck="false" width="100%" [innerHtml]="currentDescHtml" style="overflow-y: auto"></div>

      <wiz-vgroup width="100%" height="100%" style="overflow: auto"
        ><ng-container #containerInputs></ng-container>
      </wiz-vgroup>
    </wiz-vgroup>

    <wiz-vgroup width="140px"
      ><!-- zone boutons numériques -->
      <wiz-hgroup horizontalAlign="end">
        <wiz-button
          width="25px" height="25px"
          (click)="addOperator('/')"
          [wizLabel]="'$.common.operator.divide.$'"
          class="button-operator"
        ></wiz-button>
        <wiz-button
          width="25px" height="25px"
          (click)="addOperator('*')"
          [wizLabel]="'$.common.operator.multiply.$'"
          class="button-operator"
        ></wiz-button>
        <wiz-button
          #btnAdd
          width="25px" height="25px"
          (click)="addOperator('+')"
          [wizLabel]="'$.common.operator.add.$'"
          class="button-operator"
        ></wiz-button>
        <wiz-button
          width="25px" height="25px"
          (click)="addOperator('-')"
          [wizLabel]="'$.common.operator.substract.$'"
          class="button-operator"
        ></wiz-button>
      </wiz-hgroup>
      <wiz-hgroup horizontalAlign="end">
        <wiz-button width="25px" height="25px" (click)="addOperator('7')" [wizLabel]="'$.common.operator.7.$'"></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('8')" [wizLabel]="'$.common.operator.8.$'"></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('9')" [wizLabel]="'$.common.operator.9.$'"></wiz-button>
      </wiz-hgroup>
      <wiz-hgroup horizontalAlign="end">
        <wiz-button width="25px" height="25px" (click)="addOperator('4')" [wizLabel]="'$.common.operator.4.$'"></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('5')" [wizLabel]="'$.common.operator.5.$'"></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('6')" [wizLabel]="'$.common.operator.6.$'"></wiz-button>
      </wiz-hgroup>
      <wiz-hgroup horizontalAlign="end">
        <wiz-button width="25px" height="25px" (click)="addOperator('0')" [wizLabel]="'$.common.operator.0.$'"></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('1')" [wizLabel]="'$.common.operator.1.$'"></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('2')" [wizLabel]="'$.common.operator.2.$'"></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('3')" [wizLabel]="'$.common.operator.3.$'"></wiz-button>
      </wiz-hgroup>
      <wiz-hgroup horizontalAlign="end">
        <wiz-button
          width="25px" height="25px"
          (click)="showFormulaPop()"
          [wizIcon]="'icon-formula'"
          class="button-measure"
          [wizTooltip]="'$.formula.add.function.$'"
        ></wiz-button>
        <wiz-button class="button-operator" width="25px" height="25px" (click)="addOperator('.')" [wizLabel]="'$.common.operator.dot.$'"></wiz-button>
        <wiz-button
        class="button-operator"
          width="25px" height="25px"
          (click)="addOperator('(',')')"
          [wizLabel]="'$.common.operator.parenthesis.$'"
        ></wiz-button>
        <wiz-button class="button-operator" width="25px" height="25px" (click)="addOperator(';')" [wizLabel]="'$.common.operator.semicolon.$'"></wiz-button>
      </wiz-hgroup>
      <wiz-hgroup horizontalAlign="end">
        <wiz-button
          width="25px" height="25px"
          (click)="showMeasurePop()"
          [wizIcon]="'icon-measures'"
          class="button-measure"
          [wizTooltip]="'$.formula.add.measure.$'"
        ></wiz-button>
        <wiz-button
          width="25px" height="25px"
          (click)="addOperator('<')"
          [wizLabel]="'$.common.operator.inf.$'"
          class="button-operator"
        ></wiz-button>
        <wiz-button
          width="25px" height="25px"
          (click)="addOperator('>')"
          [wizLabel]="'$.common.operator.sup.$'"
          class="button-operator"
        ></wiz-button>
        <wiz-button width="25px" height="25px" (click)="addOperator('=')" [wizLabel]="'='" class="button-operator"></wiz-button>
      </wiz-hgroup>
    </wiz-vgroup>
  </wiz-hgroup>

  <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="end" padding="5px">
    <wiz-button
      #btnSave
      (click)="save()"
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      (click)="doCancel()"
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
